/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentGenerationInputs } from './VoiceAgentGenerationInputs';
import {
  VoiceAgentGenerationInputsFromJSON,
  VoiceAgentGenerationInputsFromJSONTyped,
  VoiceAgentGenerationInputsToJSON,
} from './VoiceAgentGenerationInputs';

/**
 *
 * @export
 * @interface PaginatedVoiceAgentGenerationInputsList
 */
export interface PaginatedVoiceAgentGenerationInputsList {
  /**
   *
   * @type {number}
   * @memberof PaginatedVoiceAgentGenerationInputsList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedVoiceAgentGenerationInputsList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedVoiceAgentGenerationInputsList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<VoiceAgentGenerationInputs>}
   * @memberof PaginatedVoiceAgentGenerationInputsList
   */
  results: Array<VoiceAgentGenerationInputs>;
}

/**
 * Check if a given object implements the PaginatedVoiceAgentGenerationInputsList interface.
 */
export function instanceOfPaginatedVoiceAgentGenerationInputsList(
  value: object,
): value is PaginatedVoiceAgentGenerationInputsList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedVoiceAgentGenerationInputsListFromJSON(json: any): PaginatedVoiceAgentGenerationInputsList {
  return PaginatedVoiceAgentGenerationInputsListFromJSONTyped(json, false);
}

export function PaginatedVoiceAgentGenerationInputsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedVoiceAgentGenerationInputsList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(VoiceAgentGenerationInputsFromJSON),
  };
}

export function PaginatedVoiceAgentGenerationInputsListToJSON(
  value?: PaginatedVoiceAgentGenerationInputsList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(VoiceAgentGenerationInputsToJSON),
  };
}
